module.exports = __webpack_public_path__ + "static/8a85067c7e71f05d8975c262dc779095f814470306cbf3cf80852334a257665a-bd043998ebbb396befdde28bd97f8b85.jpeg";